<template>
  <v-app>
    <defNavBar title="Ares - Find mail by Number" download home @actionClick="downloadMailAsFile" />    
    <v-main> 
      <div style="display: grid; grid-template-columns: 550px auto;">
        <div style="height: calc(100vh - 65px);">
          <div style="position: fixed; background-color: #F2F2F2; height: calc(100vh - 65px); width: 550px;">
            <div style="padding: 10px 20px;">
              <div style="display: flex; flex-direction: row; align-items: center; gap: 10px; width: 200px">        
                <v-text-field v-model="mailnr" dense label="Number" clearable style="padding-top: 20px; width: 200px;" @click:clear="reset(0)"></v-text-field>
                <v-btn dense small @click="getMail(mailnr)">find</v-btn>
              </div>
              <div v-if="!isObjectEmpty(mail)" style="display: grid; grid-template-columns: 130px 390px;">
                <div>Description</div><div>{{ mail.mail_oms }} </div>
                <div>Recipient</div><div>{{ mail.mail_to }}</div>        
                <div>Sender</div><div>{{ mail.mail_sender }}</div>
                <div>Sent</div><div>{{ mail.mail_dt }}</div>
                <div>Read before</div><div>{{ mail.mail_read }}</div>
                <div>Subject</div><div>{{ mail.mail_subject }}</div>
                <div>Caller</div><div>{{ mail.mail_caller }}</div>
                <div>User</div><div>{{ mail.mail_user }}</div>
                <div>Template</div><div>{{ mail.mail_mltp }}</div>
                <div>Key</div><div>{{ mail.mail_key1 }}</div>
                <div>Key value</div><div>{{ mail.mail_key1_waarde }}</div>
                <div>Sent to entity</div><div>{{ mail.mail_totype }}</div>
                <div>Sent to keytype</div><div>{{ mail.mail_tonaam }}</div>        
                <div>Sent to value</div><div>{{ mail.mail_towaarde }}</div>      
                <div>Attachment(s)</div><div>{{ mail.mlat.length }}</div>      
              </div>  
            </div>
          </div>
        </div>
        <div style="padding: 10px 20px">
          <div class="spinner" v-if="loading">
            <v-row>
              <v-col cols="12" span="12" align="center">
                <v-progress-circular :width="3" :size="25" color="green" indeterminate class="mr-2"></v-progress-circular>
                <span>loading...</span>
              </v-col>
            </v-row>  
          </div>
          <v-simple-table>
            <template v-slot:default>
              <tbody>
                <tr v-for="(mlat,i) in mail.mlat" :key="i" @click="showMlat(mlat.mlat_url)">
                  <td>{{mlat.mlat_filenaam}}</td>
                </tr>                  
              </tbody>  
            </template>  
          </v-simple-table>          
          <div v-html="mail.mail_tekst"></div>
        </div>
      </div>
    </v-main>
  </v-app>
</template>

<script>
 import defNavBar from '@/components/ui/navbars/navbar.vue';
 export default {
  components: {
    defNavBar
  },
  data() {
    return {
      loading: false,
      mail: {},
      mailnr: null
    }
    
  },
  mounted() {
                document.title = 'Find Mail'
  },
  methods: {
    getMail(v) {
      this.mail={}
      this.loading=true;
      this.$axios
        .post("ares/json/ares/misc/getMailByNumber.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getMailByNumber"
          },
          getMailByNumber: {
            mail_nr: v
        }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
            this.mail={}
          } else {
            this.mail = res.data.getMail;
          }
        })
        .finally(() => {
          this.loading = false; 
          document.querySelector(".spinner").classList.add('d-none');
        });      
    },
    downloadMailAsFile(){
      if(this.isObjectEmpty(this.mail)){return}
      try{
        let fileContent = `${this.mail.mail_tekst}<br><br>Subject: ${this.mail.mail_subject}<br>Sent: ${this.mail.mail_dt}`;
        let fileBlob = new Blob([fileContent ], { type: 'text/plain' });
        let temp = document.createElement('a');
        temp.download = `${this.mail.mail_oms}.html`;
        temp.href = window.URL.createObjectURL(fileBlob);
        temp.click();
      } catch(err){
        console.log(err.message);
      }
    },
    showMlat(url) {
      window.open(url,'_blank');
    },
    isObjectEmpty(objectName){
      return JSON.stringify(objectName) === "{}"
    },
    reset(v){
      this.getMail(v)
    }
  }
};

</script> 
